import { AssetFinancingPool } from "@/graphql/__generated__/graphql-operations";
import { calculateAnnualizedInterest, formatNumberLocale } from "@/utils/helpers";
import { useIntl } from "react-intl";
import { ServiceProviderDetails } from "@/components/shared";
import TextInfoGroup from "@/components/shared/common/TextInfoGroup";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@/context/ThemeProvider";
import { FramerDiv } from "@/components/shared/framer";
import { Card } from "@/components/ui/card";

type Props = {
  assetFinancingPool: AssetFinancingPool;
}

function PortfolioCard(props: Props) {

  // Props
  const { assetFinancingPool } = props;

  // Hooks
  const intl = useIntl();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  function handleInvestHyperlink(assetFinancingPool: AssetFinancingPool) {
    if (assetFinancingPool.spdetails.name) {
      navigate(`/user/investment?afpId=${assetFinancingPool._id}`);
    }
  }

  return(
    <Card>
      <FramerDiv
        whileHover={{ transition: { duration: 0.3 }, borderColor: darkMode ? "#EE5300" : "#320085" }}
        data-cy="portfolio-card"
        onClick={() => handleInvestHyperlink(assetFinancingPool)}
        className="flex flex-col rounded dark:bg-mfdarkbase px-3 pt-2 pb-2 text-gray-700 select-none dark:text-gray-100 bg-gray-100
                  border-2 border-transparent cursor-pointer w-auto"
      >
        <div className="grid grid-cols-12 gap-4 h-full">
          {/* Logo and name */}
          <div className="col-span-12 sm:col-span-6">
            <ServiceProviderDetails
              serviceProviderId={assetFinancingPool.spdetails._id}
              className="lg:grow-1"
              titleClassName="text-sm"
              logoSize="small"
            />
          </div>
          {/* Lower container */}
          <div className="col-span-6 sm:col-span-3">
            {/* Open to invest */}
            <TextInfoGroup
              className="max-w-[100px]"
              label={t("dashboard.portfoliocard.opentoinvest")}
              content={formatNumberLocale(
                intl,
                assetFinancingPool.financinglimit-assetFinancingPool.amountinvested,
                "currency", true, false,
              )}
            />
          </div>
          <div className="col-span-6 sm:col-span-3">
            {/* Interest p.a. --> */}
            <TextInfoGroup
              className="max-w-[100px]"
              label={t("dashboard.portfoliocard.interest")}
              content={calculateAnnualizedInterest(assetFinancingPool.interest, assetFinancingPool.rewardpayoutperiod)}
            />
          </div>
        </div>
      </FramerDiv>
    </Card>
  );
}

export default PortfolioCard;
